import { tWithKeyAttr as t } from "../../i18nHelper";
import questionnaireStyles from "./questionnaire.module.css";
import { useInView } from "react-intersection-observer";
import questionnaireDoctor from "../../images/questionnaire_doctor.png";

function Questionnaire({ link, userName = "" }: { link: string; userName?: string }) {
  const { ref, inView } = useInView({
    threshold: 1,
  });

  return (
    <>
      <a href={link} ref={ref} className={questionnaireStyles.questionnaire}>
        <img
          src={questionnaireDoctor}
          alt="bpreven doctor"
          className={questionnaireStyles.questionnaire__doctor}
        />

        <p className={questionnaireStyles.questionnaire__answer}>
          {/*{getStartQuestion()}*/}
          {t('HELLO')}{userName},<span>{t('I_AM_ALWAYS_HERE_FOR_YOU')}</span>
        </p>
      </a>
      {!inView && (
        <div className={`${questionnaireStyles.questionnaire_small}`}>
          <img
            src={questionnaireDoctor}
            alt="bpreven doctor"
            className={questionnaireStyles.questionnaire__doctor}
          />
          <p className={questionnaireStyles.questionnaire__answer_small}>
            {t('I_AM_ALWAYS_HERE_FOR_YOU_1')}</p>
        </div>
      )}
    </>
  );
}

export default Questionnaire;
